<template lang="pug">
section.comments.comments-wrap
  h2.comments-title Comments
  b-media.comment( v-for='comment in comments' :key='comment.id' )
    b-img.gravatar( :src='comment.author_avatar_urls[48]' )
    h5.comment-author {{ comment.author_name }}
    .comment-content( v-html='comment.content.rendered' )
  .message( v-if='!comments.length' ) none yet
  comment-form( v-if='!readOnly' :first='!comments.length' )
</template>

<script lang="js">
import CommentForm from './comment-form'

export default {
  name: 'comments',
  mixins: [],
  components: { CommentForm },
  props: {
    comments: {
      type: Array,
      default: () => []
    },
    postId: {
      type: Number,
      default: 0
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    }
  },
  created() {},
  mounted() {
    if ( !this.comments.length && this.postId ) {
      // TODO: this
    }
  },
  methods: {},
  computed: {}
}
</script>

<style lang="scss">
@import "~breakpoint-sass/stylesheets/breakpoint";
@import "@/scss/vars";

.comment {
  margin-bottom: 35px;
  &-author, &-content {
    margin-left: 70px;
  }
  &-author {
    font-weight: bold;
    margin-bottom: 10px;
  }
  &-form-wrap {
    margin-top: 50px;
    margin-bottom: 50px;
    h3 {
      margin-bottom:30px;
      border-bottom:1px solid $light-grey;
      padding-bottom:22px;
    }
    .btn {
      margin-top:15px;
    }
    textarea {
      min-height:140px;
    }
    label {
      margin-bottom: 0;
      font-weight: normal;
    }
    input, input.form-control {
      font-size: 2rem;
      border: none;
      border-radius: 0;
      border-bottom: 2px solid #aaa;
      background: transparent;
      box-shadow: none !important;
      color: white;
      background: transparent;
      height: unset;
      padding: 8px;
      &:focus {
        color: white;
        background: transparent;
        border-bottom-color: deepskyblue;
      }
    }
    textarea {
      border-radius: 0;
      box-shadow: none !important;
      border: 1px solid lightgrey;
    }
  }
  .gravatar {
    float:left;
    margin-top:5px;
  }
}
</style>
